module.exports = __webpack_public_path__ + "powerDown.6bb359d1.gif";


//////////////////
// WEBPACK FOOTER
// ./client/components/powerDown.gif
// module id = 486
// module chunks = 0